import axios from "axios";
import { ToastChakra } from "../helpers/toast";
import api from "../helpers/api";

const baseURL = process.env.REACT_APP_API_URL;
const getAllCiudades = async (data) => {
    const {page, perPage} = data;
    const response = await api.get(`${baseURL}/ciudad/list?pagina=${page}&cantidadPagina=${perPage}`);
    //console.log('esto traigo en servicio ciudad:', response.data);
    return response.data;  // Aquí obtienes el objeto con `data` y `pagination`
}



const getListSelectCiudad = async () => {
    const response = await api.get(`${baseURL}/ciudad/listar/select`);
    if (response.status === 200 || response.status === 201) {
        return response.data;
    }
}

const getCiudad = async (id, token) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'x-token': token
        },
    }
    const response = await axios.get(`${baseURL}/ciudad/${id}`, config);
    return response.data.ciuadad;
}

const createCiudad = async (data) => {
    const response = await api.post(`${baseURL}/ciudad/crear`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('CIUDAD CREADO', 'La ciudad se ha creado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

// Update
const updateCiudad = async (data) => {
    const response = await api.put(`${baseURL}/ciudad/actualizar/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('CIUDAD MODIFICADO', 'La ciudad se ha modificado correctamente', 'success', 3000, 'bottom-right');
        return response.data
    }
}

// Delete
const deleteCiudad = async (id) => {

    const response = await api.delete(`${baseURL}/ciudad/borrar/${id}`);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('CIUDAD ELIMINADO', 'La ciudad se ha eliminado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

const ciudadService = {
    getAllCiudades,
    getCiudad,
    createCiudad,
    updateCiudad,
    deleteCiudad,
    getListSelectCiudad
}

export default ciudadService;